import React, { useEffect, useState } from 'react';
import {
  Dialog, Button, Typography, Box, Fade, IconButton,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import RefreshIcon from '@mui/icons-material/Refresh';

const ErrorModal = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const handler = (e) => {
      setMessage(e.detail?.message || 'Hubo un error en el servidor.');
      setOpen(true);
    };
    window.addEventListener('siam-server-error', handler);
    return () => window.removeEventListener('siam-server-error', handler);
  }, []);

  const handleClose = () => setOpen(false);
  const handleRetry = () => { setOpen(false); window.location.reload(); };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}
      PaperProps={{
        elevation: 24,
        sx: {
          borderRadius: 3,
          overflow: 'hidden',
          background: '#fff',
        },
      }}
      sx={{ zIndex: 99999 }}
    >
      {/* Barra superior roja con degradado */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #c62828 0%, #e53935 60%, #ef5350 100%)',
          pt: 4, pb: 3, px: 3,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {/* Botón cerrar arriba a la derecha */}
        <IconButton
          onClick={handleClose}
          size="small"
          sx={{
            position: 'absolute', top: 10, right: 10,
            color: 'rgba(255,255,255,0.7)',
            '&:hover': { color: '#fff', background: 'rgba(255,255,255,0.15)' },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        {/* Ícono principal con fondo circular */}
        <Box
          sx={{
            width: 72, height: 72, borderRadius: '50%',
            background: 'rgba(255,255,255,0.15)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mb: 2,
            boxShadow: '0 0 0 10px rgba(255,255,255,0.07)',
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: 42, color: '#fff' }} />
        </Box>

        <Typography variant="h6" fontWeight={700} color="#fff" textAlign="center" letterSpacing={0.5}>
          Error de conexión
        </Typography>
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.75)', mt: 0.5 }}>
          No se pudo completar la operación
        </Typography>
      </Box>

      {/* Cuerpo */}
      <Box sx={{ px: 3, pt: 3, pb: 1 }}>
        {/* Detalle del error */}
        <Box
          sx={{
            display: 'flex', alignItems: 'flex-start', gap: 1.5,
            background: '#fff5f5', border: '1px solid #ffcdd2',
            borderRadius: 2, p: 2, mb: 2,
          }}
        >
          <WifiOffIcon sx={{ color: '#e53935', mt: 0.2, flexShrink: 0 }} />
          <Typography variant="body2" color="text.secondary" lineHeight={1.6}>
            {message}
          </Typography>
        </Box>

        <Typography variant="caption" color="text.disabled" display="block" textAlign="center" mb={2}>
          Si el problema persiste, contactá al administrador del sistema.
        </Typography>
      </Box>

      {/* Acciones */}
      <Box sx={{ px: 3, pb: 3, display: 'flex', gap: 1.5 }}>
        <Button
          fullWidth
          variant="outlined"
          onClick={handleClose}
          sx={{
            borderRadius: 2, textTransform: 'none', fontWeight: 600,
            borderColor: '#e0e0e0', color: 'text.secondary',
            '&:hover': { borderColor: '#bdbdbd', background: '#fafafa' },
          }}
        >
          Cerrar
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={handleRetry}
          startIcon={<RefreshIcon />}
          sx={{
            borderRadius: 2, textTransform: 'none', fontWeight: 600,
            background: 'linear-gradient(135deg, #c62828, #e53935)',
            boxShadow: '0 4px 14px rgba(229,57,53,0.4)',
            '&:hover': {
              background: 'linear-gradient(135deg, #b71c1c, #c62828)',
              boxShadow: '0 6px 18px rgba(229,57,53,0.5)',
            },
          }}
        >
          Reintentar
        </Button>
      </Box>
    </Dialog>
  );
};

export default ErrorModal;
